import { Injectable } from '@angular/core';
import { isDate, isValid } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

@Injectable({
  providedIn: 'root',
})
export class DateFormattingService {
  public formatDateWithOffset(date: Date, pattern: string, offset: number): string | null {
    // in case of bad date format, return null to prevent textContent modification
    if (!isDate(date) || !isValid(date) || !offset) {
      return null;
    }

    const timeZoneString = `Etc/GMT${offset > 0 ? '-' : '+'}${Math.abs(offset)}`;

    const formattedCorrectDate = formatInTimeZone(date, timeZoneString, pattern);

    return formattedCorrectDate;
  }
}
